module.exports = __webpack_public_path__ + "static/planning-5872aa56b683538e36c337c5ead9292d.png";